// extracted by css-extract-rspack-plugin
export default {"paragraph":"content-editor-plugin-paragraph-Paragraph-paragraph-f8811a33"};